import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  detailsTitle: {
    id: "course-authoring.schedule-section.details.title",
    defaultMessage: "Course details",
  },
  detailsDescription: {
    id: "course-authoring.schedule-section.details.description",
    defaultMessage: "Provide useful information about your course",
  },
  dropdownLabel: {
    id: "course-authoring.schedule-section.details.dropdown.label",
    defaultMessage: "Course language",
  },

  dropdownHelpText: {
    id: "course-authoring.schedule-section.details.dropdown.help-text",
    defaultMessage:
      "Identify the course language here. This is used to assist users find courses that are taught in a specific language. It is also used to localize the 'From:' field in bulk emails.",
  },
  dropdownEmpty: {
    id: "course-authoring.schedule-section.details.dropdown.empty",
    defaultMessage: "Select language",
  },
  dropdownLabelForCourse: {
    id: "course-authoring.schedule-section.details.dropdowncourse.empty",
    defaultMessage: " Course Type",
  },
  dropdownHelpTextForCourse: {
    id: "course-authoring.schedule-section.details.dropdown.help-text.forcourse",
    defaultMessage: "Select Course Type.",
  },
  dropdownEmptyForCourse: {
    id: "course-authoring.schedule-section.details.dropdowncourse.empty",
    defaultMessage: "Select course",
  },
  dropdownLabelForCourseDuration: {
    id: "course-authoring.schedule-section.details.dropdown.help-text.forcourseduration",
    defaultMessage: "Course Duration",
  },
  dropdownHelpTextForCourseDuration: {
    id: "course-authoring.schedule-section.details.dropdown.help-text.forcourse",
    defaultMessage: "Select Course Duration.",
  },
});

export default messages;
